<template>
    <div v-if="customer">
        <div v-html="$t('you_have_logged_in_will_use_below_information_to_book')"></div>
        <hr/>
        <div>{{ customer.name }}</div>
        <div>{{ customer.email }}</div>
        <div>+{{ customer.phone_calling_code }}-{{ customer.phone_number }}</div>
        <hr/>
        <div>
            <span>{{ $t('not_you') }}</span> <a href="javascript:void(0)" @click.stop.prevent="doLogOut">{{ $t('click_here_to_log_out') }}</a>
        </div>
    </div>
    <div v-else-if="logInEnabled" class="text-center">
        <button class="btn btn-secondary" @click="$emit('request-login')">{{ $t('login_required_click_to_login') }}</button>
    </div>
    <div v-else>
        <div class="form-group row">
            <div v-if="(!this.hasValidPhoneNumber || !this.hasValidPhoneCallingCode) && showInvalid"
                class="col-12 pl-3">
                <div class="alert alert-warning">{{$t('message.please_fill_your_phone')}}</div>
            </div>
            <label class="col-sm-3 form-control-label">{{$t('message.phone')}}</label>
            <div class="col-sm-9">
                <p class="form-control-static">
                    <vue-phone-input
						@blur="onPhoneInputBlur"
                        ref="phone-input"
                        name="phone"
                        :code="countryCode"
                        :onChange="onPhoneNumberChange"
                        :placeholder="$t('message.customer_phone_placeholder')"
                    />
                </p>
            </div>
        </div>
        <div class="form-group row">
            <div v-if="!this.hasValidName && showInvalid"
                class="col-12 pl-3">
                <div class="alert alert-warning">{{$t('message.please_fill_your_name')}}</div>
            </div>
            <label class="col-sm-3 form-control-label">{{$t('message.name')}}</label>
            <div class="col-sm-9">
                <p class="form-control-static">
                    <input cy-customer-name-input name="name" type="text" autocomplete="new-name" class="form-control" v-model="name" :disabled="existingMemberState === 'EXISTING'" :placeholder="existingMember ? existingMember.masked_name : $t('please_enter_name')">
                </p>
            </div>
        </div>
        <div class="form-group row">
            <div v-if="!this.hasValidEmail && showInvalid"
                class="col-12 pl-3">
                <div class="alert alert-warning">{{$t('message.please_correct_your_email')}}</div>
            </div>
            <label class="col-sm-3 form-control-label">{{$t('message.email')}}</label>
            <div class="col-sm-9">
                <p class="form-control-static">
                    <input cy-customer-email-input type="text" name="email" autocomplete="new-email" class="form-control" v-model="email" :disabled="existingMemberState === 'EXISTING'"  :placeholder="existingMember ? existingMember.masked_email : $t('please_enter_email')">
                </p>
            </div>
        </div>

        <hr class="mt-0" v-if="facebookPageToContactCustomer">
        <div class="form-group row" v-if="facebookPageToContactCustomer">
            <div class="col-12">
                <label class="form-control-label">{{$t('message.fb_contact_customer')}}</label>
                <p class="text-muted">{{$t('message.fb_contact_customer_hint')}}</p>
                <div class="form-control-static">
                    <div
                        class="fb-messenger-checkbox"
                        :origin="'https://' + provider.landingLink"
                        :page_id="facebookPageToContactCustomer.page_id"
                        :messenger_app_id="context.fbAppId"
                        :user_ref="context.fbUserRef"
                        allow_login="true"
                        size="small"
                        skin="light"
                        center_align="false">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CapabilityManager from '../../bu/CapabilityManager.js';
import vuePhoneInput from '../../components/vue-phone-input/index.vue';
import promptConfirm from '../../mixins/prompt-confirm.js';
import api from '../../mixins/api.js';
import RootStore from '../../stores/root';
import { mapActions, mapGetters } from 'vuex';
import { isValidPhoneNumber } from 'libphonenumber-js';
import Constants from '../../constants';

export default {
    store: RootStore,
	mixins: [promptConfirm, api],
    components: { vuePhoneInput },
    props: {
        logInEnabled: { type: Boolean, default: false},
        context: {type: Object, required: true},
        provider: {type: Object, required: true},
        emailRequired: {type: Boolean, default: true}
    },
    data() {
        this.$_capabilityManager = new CapabilityManager(
            this.provider.grade,
            this.provider.capabilities
        );

        return {
			existingMemberState: 'UNCHECKED', // UNCHECKED, EXISTING, NONE
			existingMember: null,
            contactViaFb: false,
            countryCode: this.context.countryCode,
            name: '',
            phoneCallingCode: '',
            phoneNumber: '',
            email: '',
            showInvalid: false
        };

    },

    mounted() {
        this.$refs['phone-input']?.setCode('tw');

        window.fbAsyncInit = () => {
            FB.init({
                appId      : this.context.fbAppId,
                autoLogAppEvents : true,
                xfbml            : true,
                version          : 'v6.0'
            });
            FB.Event.subscribe('messenger_checkbox', (e) => {
                if (e.event == 'checkbox') {
                    if (e.state === 'checked') {
                        this.contactViaFb = true;
                        this.confirmFBOptIn(e);
                    } else {
                        this.contactViaFb = false;
                    }
                }
            });
        };

        (function(d, s, id){
            var lang = getSharedLang() == 'zh' ? 'zh_TW' : 'en_US';
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.async = true;
            js.defer = true;
            js.src = "//connect.facebook.net/" + lang + "/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    },

    computed: {
        ...mapGetters({
            customer: 'app/customer'
        }),
		hasExistingMemberData() {
			return this.existingMemberState === 'EXISTING' 
		},
        facebookPageToContactCustomer() {
            if (this.$_capabilityManager.isFBCustomerContactAvailable()) {
                let page = _.find(this.provider.pages, (p) => {
                    return !!p.customer_contact_enabled
                });
                return page;
            }
            return false;
        },

        hasValidAnswer() {
            if (this.logInEnabled && this.customer) {
                return true;
            }
            return this.hasValidName && this.hasValidPhoneNumber && this.hasValidPhoneCallingCode && this.hasValidEmail;
        },

        hasValidName() {
            return this.name.length >= 2 || this.hasExistingMemberData;
        },

        hasValidPhoneCallingCode() {
            return !!this.phoneCallingCode && !!this.countryCode;
        },

        hasValidPhoneNumber() {
            return !!this.countryCode && isValidPhoneNumber(this.phoneNumber, this.countryCode?.toUpperCase());
        },

        hasValidEmail() {
            if (!this.emailRequired && !this.email) {
                // it's ok to have no email entered when it's not requried
                return true;
            }

			if (this.hasExistingMemberData) {
				return true;
			}

            return this.email && this.email.match(Constants.validator.email);
        },
    },

    methods: {
        ...mapActions({
            logOut: 'app/logOutCustomer'
        }),
        async doLogOut() {
            await this.logOut();
        },
		onPhoneInputBlur() {
			if (this.hasValidPhoneNumber && (this.lastCheckedPhone !== this.phoneCallingCode + this.phoneNumber)) {
				const close = this.promptLoading(this.$t('getting_member_data'));
				this.existingMember = null;
				this.existingMemberState = 'UNCHECKED';
				this.checkExistingMember(this.phoneCallingCode, this.phoneNumber, (result, error) => {
					close();
					if (!error) {
						this.existingMemberState = 'EXISTING';
                        this.name = "";
                        this.email = "";
						this.$set(this, 'existingMember', result.data);
					} else {
                        this.existingMemberState = 'NONE';
						this.existingCustomer = null;
					}
					this.lastCheckedPhone = this.phoneCallingCode + this.phoneNumber;
				});
			}
		},
        confirmFBOptIn(event) {
            FB.AppEvents.logEvent('MessengerCheckboxUserConfirmation', null, {
                'app_id': this.context.fbAppId,
                'page_id': this.facebookPageToContactCustomer.page_id,
                'ref': event.ref,
                'user_ref': event.user_ref
            });
        },

        onAnswerChange(newAnswer) {
            this.answer = newAnswer;
        },

        highlightInvalidState() {
            this.showInvalid = true;
        },

        onPhoneNumberChange(phoneInputComponent) {
            this.phoneNumber = phoneInputComponent.phoneNumber;
            this.phoneCallingCode = new String( phoneInputComponent.availableData[phoneInputComponent.countryCode].dialCode);
            this.countryCode = phoneInputComponent.countryCode;
        },

        getCountryItem() {
            const phoneInputComponent = this.$refs['phone-input'];
            return phoneInputComponent.availableData[phoneInputComponent.countryCode]
        },

        getDataToPersist() {
            return {
                name: this.name,
                phone_calling_code: this.phoneCallingCode,
                phone_number: this.phoneNumber,
                email: this.email,
                fb_user_ref: this.contactViaFb ? this.context.fbUserRef : null
            };
        }
    }
}
</script>

<style lang="scss" scoped>
    /deep/ .intl-phone-input {
        width: 100%;
    }

    /deep/ .intl-phone-input input[type="text"] {
        border: solid 1px rgba(197,214,222,.7);
        box-shadow: none;
    }
</style>

<i18n>
{
	"en": {
		"getting_member_data": "Checking...",
		"please_enter_name": "Enter your name",
		"please_enter_email": "Enter your email",
        "you_have_logged_in_will_use_below_information_to_book": "You've logged in.<br>Will booking with following information.",
        "not_you": "Not you?",
        "click_here_to_log_out": "Click here to log out",
        "login_required_click_to_login": "Log In To Continue"
	},
	"zh": {
		"getting_member_data": "取得資料中...",
		"please_enter_name": "請輸入姓名",
		"please_enter_email": "請輸入 Email",
        "you_have_logged_in_will_use_below_information_to_book": "您已登入，將以下方資訊進行預約",
        "not_you": "這不是你嗎？",
        "click_here_to_log_out": "點此登出",
        "login_required_click_to_login": "請點此登入"
	}
}
</i18n>